<template>
    <PaymentForm />
  </template>
  
  <script>
  import PaymentForm from '@/components/payment/PaymentForm.vue';
  
  export default {
    name: "PaymentCreatePage",
    components: {
      PaymentForm,
    },
  };
  </script>
  